<!--
 * @Author: guoguo ybbhai@hotmail.com
 * @Date: 2023-09-25 16:26:30
 * @LastEditors: guoguo ybbhai@hotmail.com
 * @LastEditTime: 2023-11-23 21:37:40
 * @FilePath: \web\src\views\other.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div>
    <div>
      <el-row class="underline marb20">
        <span class="color"><b>友情链接</b></span>
      </el-row>
      <div>
        <div v-for="(item, i) in linkList" :key="i" class="aLianJ marb10">
          <a :href="item.link" class="anone" target="_blank">{{ item.name }}</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getLinkList } from '@/api/friendlyLink.js'

export default {
  name: 'other',
  data() {
    return {
      linkList: [],
      params: {
        pageSize: 5,
        total: 10,
        currentPage: 1
      }
    }
  },
  mounted() {
    this.getLinkList();
  },
  methods: {
    getLinkList() {
      getLinkList(this.params).then(res => {
        if (res.code == 200) {
          this.linkList = res.data.records;
        } else {
          this.$message({
            type: 'error',
            message: res.msg
          })
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.underline {
  border-bottom: 1px solid rgb(1, 72, 153);
}
.aLianJ {
  height: 30px;
  background-color: rgb(242, 243, 244);
  text-align: center;
  line-height: 30px;
}
.bg {
  background-color: rgb(1, 72, 153) !important;
  background: url('../assets/images/wxbg.png') no-repeat 20px 50px;
  width: 90%;
  color: white;
}
.bg2 {
  background: url('../assets/images/wbbg.png') no-repeat 20px 50px;
}
.bg,
.bg2 {
  position: relative;
  height: 120px;
}
.bg img {
  position: absolute;
  top: 12px;
  right: 26px;
}
.bg span {
  position: absolute;
  top: 20px;
  left: 25px;
}
</style>
